<template>
  <div>
    <v-dialog v-model="myValue" persistent max-width="960">
      <v-card>
        <v-card-title class="headline">原始文件信息</v-card-title>
        <v-card-text>
          <v-row
            style="margin-top: 50px"
            justify="start"
            no-gutters
            class="px-5"
          >
            <v-col cols="auto" class="text-subtitle-1 red--text">
              {{ tips }}
            </v-col>
          </v-row>
          <v-row
            style="margin-top: 50px"
            justify="start"
            no-gutters
            class="px-5"
          >
            <v-col cols="auto" class="text-subtitle-1">
              <v-sheet v-if="myData.khhqurl === 'Y'">
                <span class="text-subtitle-1 blue--text">下载地址：</span>
                <span
                  class="text-subtitle-1 blue--text text-decoration-underline"
                  style="cursor: pointer"
                  @click="toDowonload"
                  >{{ downloadUrl }}</span
                >
              </v-sheet>
              <v-btn
                large
                color="primary"
                @click="download"
                v-else-if="myData.khhqurl === 'N'"
                >点击生成下载链接</v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" @click="myValue = false">关闭</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <notice v-model="showNotice" @query="query" :data="data" />
  </div>
</template>

<script>
import notice from "./notice.vue";
export default {
  components: {
    notice,
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    download() {
      this.showNotice = true;
    },
    query() {
      this.myValue = true;
      this.$emit("query");
    },
    toDowonload() {
      window.open(this.myData.sourcefileurl, "_blank");
    },
  },
  data() {
    return {
      showNotice: false,
    };
  },
  computed: {
    myData() {
      return this.data;
    },
    myValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    downloadUrl() {
      return `${this.myData.sourcefileurl}`;
    },
    tips() {
      return `重要提醒：根据合同约定，提交报告确认单后，原始文件将于${this.Utility.fmtTime(
        this.myData.expireDate,
        "yyyy年MM月dd日"
      )}自动销毁，请尽快下载！`;
    },
  },
  watch: {},
  created() {},
};
</script>
